// ============================================================================
// view.mySubmissions — receipt-backed no-server-read surface
// ============================================================================
// MySubmissions is a navigation-only review hub. It has no route-local server
// read or command, while the shared authenticated Header separately owns the
// task badge, notifications, and HeaderWeatherChip's public weather source.
// A fictitious empty catalog resource would misstate this route-local absence,
// so the receipt records the shell/external boundary instead. The separate
// boot-release ledger and release receipt, not this declaration, authorize
// independent boot timing.
// ============================================================================

import type {NoServerReadSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: NoServerReadSurfaceDeclaration = Object.freeze({
  surface: 'view.mySubmissions',
  disposition: 'no-server-read',
});

export default declaration;
